const userConstants = {
	FEATURE: "@user",
	forms: {
		USER: "USER",
	},
	USERS_PER_PAGE: 10,
};

export default userConstants;
